import { render } from "./Index.vue?vue&type=template&id=1610022f&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=1610022f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1610022f"

export default script